<template>
  <div id="app">
    <Header />
    <Layout/>
    <Footer />
  </div>
</template>

<script>
import Layout from './components/Layout.vue'
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'

export default {
  name: 'app',
  components: {
    Footer,
    Header,
    Layout
  }
}
</script>

<style>
#app {
  min-width: 1200px;
  font-size: 16px;
}
</style>
